import { useState } from 'react';

import { ActivityDetailDrawer } from '@/components/activity/ActivityDetailDrawer';
import { Button } from '@/components/ui/Button';

import { SAMPLE_ACTIVITY } from '../sampleData';
import { State } from '../State';

export function ActivityDetailDrawerExamples() {
  const [open, setOpen] = useState(false);
  const entry = SAMPLE_ACTIVITY[0];

  return (
    <State
      title="One entry in full"
      note="A drawer that holds focus while open; Escape closes it."
    >
      <Button
        variant="secondary"
        onClick={() => setOpen(true)}
        data-testid="gallery-activity-detail-drawer-open-button"
      >
        Open the drawer
      </Button>
      <ActivityDetailDrawer
        entry={open ? entry : null}
        changes={entry.changes}
        showOrganization
        onClose={() => setOpen(false)}
        testId="gallery-activity-detail-drawer"
      />
    </State>
  );
}
